if (!customElements.get("product-modal")) {
    customElements.define(
        "product-modal",
        class ProductModal extends ModalDialog {
            constructor() {
                super();
                this.setupSplide();
            }

            colorChangeUnsubscriber = undefined;
            modalOpenedUnsubscriber = undefined;

            connectedCallback() {
                super.connectedCallback();

                this.colorChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productColorChange, (event) => {
                    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
                    this.setupSplide();
                });
                this.modalOpenedUnsubscriber = subscribe(PUB_SUB_EVENTS.modalOpened, (event) => {
                    this.splide.go(parseInt(event.data.opener.getAttribute("data-index")) - 1);
                });
            }

            disconnectedCallback() {
                if (this.modalOpenedUnsubscriber) {
                    this.modalOpenedUnsubscriber();
                }
                if (this.colorChangeUnsubscriber) {
                    this.colorChangeUnsubscriber();
                }
            }

            hide() {
                super.hide();
            }

            show(opener) {
                super.show(opener);
            }

            // setup splide sliders
            setupSplide() {
                if (this.querySelector(".js-product-modal-slider")) {
                    const slideCount = this.querySelectorAll(".js-product-modal-slider li").length;
                    const slideId = this.querySelector(".js-product-modal-slider").getAttribute("id");
                    this.splide = new Splide(`#${slideId}`, {
                        type: "loop",
                        gap: "1rem",
                        arrows: slideCount > 1,
                        drag: slideCount > 1
                    });
                    this.splide.mount();
                }
            }
        }
    );
}
